<template>
  <div class="app-container dict-manage">
    <!-- 左侧：字典类型 -->
    <div class="dict-panel dict-left">
      <div class="panel-header">
        <span>字典类型</span>
        <el-button icon="el-icon-plus" type="success" size="mini" @click="onAddType" v-permision_tjtf="'add'">新增类型</el-button>
      </div>

      <el-form class="panel-filter" :inline="true" @keyup.enter.native="onTypeFilter">
        <el-form-item label="名称">
          <el-input placeholder="字典名称" v-model="typeFilter.dict_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input placeholder="字典类型" v-model="typeFilter.dict_type" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="typeFilter.status" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" size="mini" @click="onTypeFilter">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="onTypeReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="typeTable"
        class="panel-table"
        highlight-current-row
        :data="typeList"
        height="100%"
        v-loading="typeLoading"
        @current-change="onCurrentTypeChange"
        @row-click="onTypeRowClick"
      >
        <el-table-column label="字典名称" prop="dict_name" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="字典类型" prop="dict_type" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === '0' || row.status === 0">正常</el-tag>
            <el-tag type="info" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="70">
          <template slot-scope="{ row }">
            <el-button type="text" @click.stop="onEditType(row)" v-permision_tjtf="'edit'">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="panel-pagination">
        <el-pagination
          background
          layout="prev,pager,next"
          :total="typePage.total"
          :page-size="typePage.limit"
          :current-page="typePage.page"
          @current-change="onTypePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 右侧：字典数据 -->
    <div class="dict-panel dict-right">
      <div class="panel-header">
        <span>
          字典数据
          <template v-if="selectedType">
            <span class="header-sub">（{{ selectedType.dict_name }} / {{ selectedType.dict_type }}）</span>
          </template>
        </span>
        <el-button icon="el-icon-plus" type="success" size="mini" @click="onAddData" v-permision_tjtf="'add'" :disabled="!selectedType">新增数据</el-button>
      </div>

      <template v-if="selectedType">
        <el-form class="panel-filter" :inline="true" @keyup.enter.native="onDataFilter">
          <el-form-item label="标签">
            <el-input placeholder="字典标签" v-model="dataFilter.dict_label" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="dataFilter.status" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="mini" @click="onDataFilter">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="onDataReset">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table class="panel-table" :data="dataList" height="100%" v-loading="dataLoading">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="字典标签" prop="dict_label" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="字典键值" prop="dict_value" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="排序" prop="dict_sort" align="center" width="70"></el-table-column>
          <el-table-column label="回显样式" align="center" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="listClassType(row.list_class)" v-if="row.list_class">{{ row.list_class }}</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="默认" align="center" width="70">
            <template slot-scope="{ row }">
              <el-tag type="warning" v-if="row.is_default === 'Y'">是</el-tag>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="row.status === '0' || row.status === 0">正常</el-tag>
              <el-tag type="info" v-else>停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" width="70">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onEditData(row)" v-permision_tjtf="'edit'">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="panel-pagination">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="dataPage.total"
            :page-size="dataPage.limit"
            :current-page="dataPage.page"
            @current-change="onDataPageChange"
          ></el-pagination>
        </div>
      </template>

      <div v-else class="panel-empty">
        <i class="el-icon-folder-opened"></i>
        <p>请先在左侧选择字典类型</p>
      </div>
    </div>

    <!-- 新增 / 修改字典类型 -->
    <el-dialog :visible.sync="typeDialogVisible" :title="typeIsUpdate ? '修改字典类型' : '新增字典类型'" width="560px" @closed="resetTypeForm">
      <el-form label-position="right" label-width="100px" :model="typeForm" :rules="typeFormRules" ref="typeFormRef">
        <el-form-item label="字典名称" prop="dict_name">
          <el-input placeholder="请输入字典名称" v-model="typeForm.dict_name" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="字典类型" prop="dict_type">
          <el-input
            placeholder="请输入字典类型"
            v-model="typeForm.dict_type"
            :disabled="typeIsUpdate"
            maxlength="50"
            show-word-limit
          />
          <div class="form-tip" v-if="!typeIsUpdate">字典类型一般为全大写英文，如 SYS_USER_SEX，创建后不可修改</div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="typeForm.status">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="typeForm.remark" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitType">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增 / 修改字典数据 -->
    <el-dialog :visible.sync="dataDialogVisible" :title="dataIsUpdate ? '修改字典数据' : '新增字典数据'" width="620px" @closed="resetDataForm">
      <el-form label-position="right" label-width="100px" :model="dataForm" :rules="dataFormRules" ref="dataFormRef">
        <el-form-item label="所属类型">
          <el-input :value="selectedType ? selectedType.dict_name + '（' + selectedType.dict_type + '）' : ''" disabled />
        </el-form-item>
        <el-form-item label="字典标签" prop="dict_label">
          <el-input placeholder="请输入字典标签" v-model="dataForm.dict_label" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="字典键值" prop="dict_value">
          <el-input placeholder="请输入字典键值" v-model="dataForm.dict_value" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="显示排序" prop="dict_sort">
          <el-input-number v-model="dataForm.dict_sort" :min="0" :max="9999" :step="1" :precision="0" />
        </el-form-item>
        <el-form-item label="回显样式" prop="list_class">
          <el-select v-model="dataForm.list_class" placeholder="请选择回显样式" clearable style="width: 100%">
            <el-option v-for="item in listClassOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="样式属性" prop="css_class">
          <el-input placeholder="请输入样式属性（如自定义 class）" v-model="dataForm.css_class" maxlength="50" />
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default">
          <el-radio-group v-model="dataForm.is_default">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="dataForm.remark" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dataDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitData">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictTypePageListApi,
  getDictTypeApi,
  addDictTypeApi,
  updateDictTypeApi,
  getDictDataPageListApi,
  getDictDataApi,
  addDictDataApi,
  updateDictDataApi
} from "@/api/dict"

export default {
  name: "DictManage",
  data() {
    return {
      // ===== 字典类型 =====
      typeFilter: { dict_name: "", dict_type: "", status: "" },
      typeList: [],
      typeLoading: false,
      typePage: { page: 1, limit: 10, total: 0 },
      selectedType: null,
      typeDialogVisible: false,
      typeIsUpdate: false,
      typeForm: this.getTypeFormDefault(),
      typeFormRules: {
        dict_name: [{ required: true, message: "请输入字典名称", trigger: "blur" }],
        dict_type: [{ required: true, message: "请输入字典类型", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      },

      // ===== 字典数据 =====
      dataFilter: { dict_label: "", status: "" },
      dataList: [],
      dataLoading: false,
      dataPage: { page: 1, limit: 10, total: 0 },
      dataDialogVisible: false,
      dataIsUpdate: false,
      dataForm: this.getDataFormDefault(),
      dataFormRules: {
        dict_label: [{ required: true, message: "请输入字典标签", trigger: "blur" }],
        dict_value: [{ required: true, message: "请输入字典键值", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      listClassOptions: [
        { label: "默认", value: "" },
        { label: "主要", value: "primary" },
        { label: "成功", value: "success" },
        { label: "信息", value: "info" },
        { label: "警告", value: "warning" },
        { label: "危险", value: "danger" }
      ]
    }
  },
  created() {
    this.getTypeList()
  },
  methods: {
    // ============ 字典类型 ============
    getTypeFormDefault() {
      return { dict_id: undefined, dict_name: "", dict_type: "", status: "0", remark: "" }
    },
    getTypeList() {
      this.typeLoading = true
      getDictTypePageListApi({
        page: this.typePage.page,
        pagesize: this.typePage.limit,
        dict_name: this.typeFilter.dict_name || null,
        dict_type: this.typeFilter.dict_type || null,
        status: this.typeFilter.status === "" ? null : this.typeFilter.status
      })
        .then((res) => {
          this.typeList = (res.data || res.records || []) || []
          this.typePage.total = res.count || res.total || 0
          // 重新定位已选类型，保持右侧数据面板可用
          if (this.selectedType) {
            const matched = this.typeList.find((t) => t.dict_id === this.selectedType.dict_id)
            if (matched) {
              this.selectedType = matched
              this.$nextTick(() => {
                this.$refs.typeTable && this.$refs.typeTable.setCurrentRow(matched)
              })
            } else {
              this.selectedType = null
              this.dataList = []
            }
          }
        })
        .finally(() => {
          this.typeLoading = false
        })
    },
    onTypeFilter() {
      this.typePage.page = 1
      this.getTypeList()
    },
    onTypeReset() {
      this.typeFilter = { dict_name: "", dict_type: "", status: "" }
      this.onTypeFilter()
    },
    onTypePageChange(val) {
      this.typePage.page = val
      this.getTypeList()
    },
    onTypeRowClick(row) {
      this.$refs.typeTable && this.$refs.typeTable.setCurrentRow(row)
    },
    onCurrentTypeChange(currentRow) {
      if (!currentRow) return
      this.selectedType = currentRow
      this.dataPage.page = 1
      this.dataFilter = { dict_label: "", status: "" }
      this.getDataList()
    },
    onAddType() {
      this.typeIsUpdate = false
      this.typeForm = this.getTypeFormDefault()
      this.typeDialogVisible = true
    },
    onEditType(row) {
      this.typeIsUpdate = true
      this.typeDialogVisible = true
      this.$nextTick(() => {
        getDictTypeApi({ dict_id: row.dict_id })
          .then((res) => {
            const d = (res && res.data) || row
            this.typeForm = {
              dict_id: d.dict_id,
              dict_name: d.dict_name || "",
              dict_type: d.dict_type || "",
              status: d.status === undefined || d.status === null ? "0" : String(d.status),
              remark: d.remark || ""
            }
          })
          .catch(() => {
            this.typeForm = {
              dict_id: row.dict_id,
              dict_name: row.dict_name || "",
              dict_type: row.dict_type || "",
              status: row.status === undefined || row.status === null ? "0" : String(row.status),
              remark: row.remark || ""
            }
          })
      })
    },
    submitType() {
      this.$refs.typeFormRef.validate((valid) => {
        if (!valid) return
        const loading = this.$loading({ lock: true, text: "提交中...", spinner: "el-icon-loading" })
        const reqData = {
          dict_name: this.typeForm.dict_name,
          dict_type: this.typeForm.dict_type,
          status: this.typeForm.status,
          remark: this.typeForm.remark
        }
        const done = () => {
          this.typeDialogVisible = false
          this.onTypeFilter()
        }
        if (this.typeIsUpdate) {
          reqData.dict_id = this.typeForm.dict_id
          updateDictTypeApi(reqData)
            .then(() => {
              this.$message.success("修改成功")
              done()
            })
            .finally(() => loading.close())
        } else {
          addDictTypeApi(reqData)
            .then(() => {
              this.$message.success("新增成功")
              done()
            })
            .finally(() => loading.close())
        }
      })
    },
    resetTypeForm() {
      this.typeForm = this.getTypeFormDefault()
      if (this.$refs.typeFormRef) this.$refs.typeFormRef.clearValidate()
    },

    // ============ 字典数据 ============
    getDataFormDefault() {
      return {
        dict_code: undefined,
        dict_sort: 0,
        dict_label: "",
        dict_value: "",
        dict_type: "",
        css_class: "",
        list_class: "",
        is_default: "N",
        status: "0",
        remark: ""
      }
    },
    getDataList() {
      if (!this.selectedType) return
      this.dataLoading = true
      getDictDataPageListApi({
        page: this.dataPage.page,
        pagesize: this.dataPage.limit,
        dict_type: this.selectedType.dict_type,
        dict_label: this.dataFilter.dict_label || null,
        status: this.dataFilter.status === "" ? null : this.dataFilter.status
      })
        .then((res) => {
          this.dataList = (res.data || res.records || []) || []
          this.dataPage.total = res.count || res.total || 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    onDataFilter() {
      this.dataPage.page = 1
      this.getDataList()
    },
    onDataReset() {
      this.dataFilter = { dict_label: "", status: "" }
      this.onDataFilter()
    },
    onDataPageChange(val) {
      this.dataPage.page = val
      this.getDataList()
    },
    onAddData() {
      if (!this.selectedType) {
        this.$message.warning("请先在左侧选择字典类型")
        return
      }
      this.dataIsUpdate = false
      this.dataForm = this.getDataFormDefault()
      this.dataForm.dict_type = this.selectedType.dict_type
      this.dataDialogVisible = true
    },
    onEditData(row) {
      this.dataIsUpdate = true
      this.dataDialogVisible = true
      this.$nextTick(() => {
        getDictDataApi({ dict_code: row.dict_code })
          .then((res) => {
            const d = (res && res.data) || row
            this.dataForm = this.fillDataForm(d)
          })
          .catch(() => {
            this.dataForm = this.fillDataForm(row)
          })
      })
    },
    fillDataForm(d) {
      return {
        dict_code: d.dict_code,
        dict_sort: d.dict_sort === undefined || d.dict_sort === null ? 0 : d.dict_sort,
        dict_label: d.dict_label || "",
        dict_value: d.dict_value || "",
        dict_type: d.dict_type || (this.selectedType ? this.selectedType.dict_type : ""),
        css_class: d.css_class || "",
        list_class: d.list_class || "",
        is_default: d.is_default || "N",
        status: d.status === undefined || d.status === null ? "0" : String(d.status),
        remark: d.remark || ""
      }
    },
    submitData() {
      this.$refs.dataFormRef.validate((valid) => {
        if (!valid) return
        const loading = this.$loading({ lock: true, text: "提交中...", spinner: "el-icon-loading" })
        const reqData = {
          dict_sort: this.dataForm.dict_sort,
          dict_label: this.dataForm.dict_label,
          dict_value: this.dataForm.dict_value,
          dict_type: this.selectedType.dict_type,
          css_class: this.dataForm.css_class,
          list_class: this.dataForm.list_class,
          is_default: this.dataForm.is_default,
          status: this.dataForm.status,
          remark: this.dataForm.remark
        }
        const done = () => {
          this.dataDialogVisible = false
          this.getDataList()
        }
        if (this.dataIsUpdate) {
          reqData.dict_code = this.dataForm.dict_code
          updateDictDataApi(reqData)
            .then(() => {
              this.$message.success("修改成功")
              done()
            })
            .finally(() => loading.close())
        } else {
          addDictDataApi(reqData)
            .then(() => {
              this.$message.success("新增成功")
              done()
            })
            .finally(() => loading.close())
        }
      })
    },
    resetDataForm() {
      this.dataForm = this.getDataFormDefault()
      if (this.$refs.dataFormRef) this.$refs.dataFormRef.clearValidate()
    },
    listClassType(val) {
      const map = { primary: "primary", success: "success", info: "info", warning: "warning", danger: "danger" }
      return map[val] || "info"
    }
  }
}
</script>

<style scoped>
.dict-manage {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
}
.dict-panel {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  box-sizing: border-box;
  overflow: hidden;
}
.dict-left {
  width: 40%;
  min-width: 360px;
}
.dict-right {
  flex: 1;
  min-width: 0;
}
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 10px;
}
.header-sub {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}
.panel-filter {
  flex: 0 0 auto;
}
.panel-filter ::v-deep .el-form-item {
  margin-bottom: 10px;
}
.panel-table {
  flex: 1 1 auto;
  margin-top: 4px;
}
.panel-pagination {
  flex: 0 0 auto;
  text-align: right;
  padding-top: 10px;
}
.panel-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}
.panel-empty i {
  font-size: 56px;
  margin-bottom: 12px;
}
.panel-empty p {
  font-size: 14px;
  margin: 0;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}
</style>
